module.exports = __webpack_public_path__ + "static/media/NewScreen1.ae1fc3dd.png";